import React from "react";
import { ReactComponent as WallArtSvg } from "../svg/wall-art.svg";

export default function WallArtIcon({ size = 64, color = "#32363F", ...props }) {
  return <WallArtSvg width={size} height={size} style={{ color }} {...props} />;
}
